
























import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class ExternalId extends mixins(PlanLimitsMixin) {
  @Prop() conditions: any;
  value: string = 'IS_NOT_EMPTY';
  predicate: string = 'EQUALS';

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any) {
    if(!value.externalId) {
      this.$set(this.conditions, 'externalId', {
        predicate: 'EQUALS',
        values: 'IS_NOT_EMPTY'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string) {
    this.$set(this.conditions.externalId, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string) {
    this.$set(this.conditions.externalId, 'predicate', value);
  }

  mounted() {
    this.value = this.conditions.externalId.values;
  }

}
